import React from 'react'
import { ProductApi } from '../../api/product_api'

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Notification from '../Notifications'

import { Capitalize } from '../../utils/misc'


const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };

export class ProductConfigurationView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            attributes: null,
            productAttributes: null,
            poductTypeName: null,
            disabledType: true,
            attrTypeName: null,
            disabledAttrType: true,
            attributeType: "string",
            showMsg: false,
            msg: null,
            msgType: "error",
            newProductType: { "name": "", "attributes": [] }

        };
        this.setProductTypeName = this.setProductTypeName.bind(this);
        this.setAttributeType = this.setAttributeType.bind(this);
        this.createAttribute = this.createAttribute.bind(this)
        this.createProductType = this.createProductType.bind(this)
        this.manageAttribute = this.manageAttribute.bind(this)
        this.setAttrTypeName = this.setAttrTypeName.bind(this)
        this.handleClose = this.handleClose.bind(this)

    }

    componentDidMount() {
        ProductApi.getAttributes()
            .then((response) => {
                let attrs = []
                response.data.results.map((data) => {
                    attrs.push({ "name": data.name, "id": data.id, "type": data.type })
                });
                return attrs;
            })
            .then((data) => {
                this.setState({ attributes: data })
            })
    }

    createProductType(e) {
        e.preventDefault()
        if (this.state.newProductType['name'].trim() == "") {
            return;
        }
        this.setState({disabled: true});
        const newProd = this.state.newProductType
        this.setState({newProductType:{"name":"", "attributes": []}})
        ProductApi.createProductType(newProd)
            .then((response) => {
                return response.data;
            })
            .then((data) => {
                this.setState({ showMsg: true, msgType: "success", msg: "Tipo de Producto creado" })
            })
            .catch((error) => {
                this.setState({ showMsg: true, msgType: "error", msg: error.response.data.name })
            })
    }

    createAttribute(e) {
        e.preventDefault()
        if (this.state.attributes && this.state.attributes.find(attr => attr.name.toLowerCase() == this.state.attrTypeName.toLowerCase())) {
            this.setState({ showMsg: true, msgType: "error", msg: "El atributo ya existe" })
        }
        else {
            let atrrName = Capitalize(this.state.attrTypeName)
            const attribute = { "name": atrrName,  "type": this.state.attributeType }
            ProductApi.createAttribute(attribute)
                .then((response) => {
                    return response.data
                })
                .then((data)=>{
                    let newAttrs = this.state.attributes
                    const attribute = { "name": data.data.name,  "type": data.data.type, "id": data.data.id }
                    newAttrs.push(attribute)
                    this.setState({attributes: newAttrs, showMsg: true, msgType: "success", msg: "Atributo creado" })
            
                })
                .catch((error) => {
                    console.log(error)
                })
            
        }

    }

    setProductTypeName(e) {
        let newProdType = this.state.newProductType
        newProdType['name'] = e.target.value.trim()
        this.setState({ newProductType: newProdType })

    }

    setAttributeType(e) {
        this.setState({ attributeType: e.target.value })
    }

    setAttrTypeName(e) {
        const attrTypeName = e.target.value.trim()
        this.setState({ attrTypeName: attrTypeName, disabledAttrType: attrTypeName == "" })
    }

    handleClose(event, reason) {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ showMsg: false });
    }
    manageAttribute(e) {
        const attrId = e.target.value
        let newProdType = this.state.newProductType
        if (e.target.checked) {
            newProdType['attributes'].push(attrId)
        }
        else {
            newProdType['attributes'].pop(attrId)
        }
        this.setState({ newProductType: newProdType })
    }
    render() {
        let items = null;
        if (this.state.attributes) {
            items = this.state.attributes.map(attribute =>
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={this.manageAttribute}
                            value={attribute.id}
                            
                        />
                    }
                    key={attribute.id}
                    label={attribute.name}
                />
            );
        }
        return (

            <div style={{ marginTop: 50 }}>
                <div className='col-md-6'>
                    <Typography variant="h6" gutterBottom>
                        Nombre del tipo de producto
                    </Typography>
                    <TextField
                        placeholder="Nombre tipo de producto"
                        type="text"
                        onInput={toInputUppercase}
                        value={this.state.newProductType["name"]}
                        onChange={this.setProductTypeName}
                    />
                </div>

                <div className='col-md-6' >
                    <Typography variant="h6" gutterBottom>
                        Atributos del tipo de producto
                    </Typography>
                    <Divider />
                    {items}
                </div>
                <div className="col-md-8"></div>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={this.state.newProductType.name.trim() == ""}
                    onClick={this.createProductType}
                >
                    Crear Tipo producto
                </Button>
                <div style={{ marginTop: 40 }}>
                    <Divider />
                    <div className='col-md-10' style={{ marginTop: 10 }}>
                        <Typography variant="h6" gutterBottom>
                            Nombre del atributo y tipo
                    </Typography>
                    </div>
                    <div className='col-md-3' style={{ marginTop: 10 }}>
                        <TextField
                            onInput={toInputUppercase}
                            placeholder=""
                            type="text"
                            onChange={this.setAttrTypeName}
                        />
                    </div>
                    <div className='col-md-5'>
                        <form autoComplete="off">
                            <FormControl >
                                <InputLabel htmlFor="attr-type">Tipo</InputLabel>
                                <Select
                                    value={this.state.attributeType}
                                    onChange={this.setAttributeType}
                                    inputProps={{
                                        name: 'attribute',
                                        id: 'attr-type',
                                    }}
                                >
                                    <MenuItem value={"string"}>Texto</MenuItem>
                                    <MenuItem value={"integer"}>Numero</MenuItem>
                                    <MenuItem value={"boolean"}>Si/No</MenuItem>
                                </Select>
                            </FormControl>
                        </form>
                    </div>
                    <div className="col-md-10"></div>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={this.state.disabledAttrType}
                        onClick={(e) => this.createAttribute(e)}
                    >
                        Crear Atributo
                </Button>
                </div>

                <Notification
                    open={this.state.showMsg}
                    variant={this.state.msgType}
                    message={this.state.msg}
                    onClose={this.handleClose}
                />

            </div>

        )

    }
}


// WEBPACK FOOTER //
// ./src/components/Products/ProductConfiguration.js